<div class="back-general public-form">
    <div class="public-form__container">
        @if (title) {
            <h1>{{ title }}</h1>
        }
        <div class="public-form__card surface-card">
            @switch (currentState) {
                @case ('loading') {
                    <div class="public-form__status">
                        <i class="pi pi-spin pi-spinner public-form__spinner"></i>
                        <p>Cargando…</p>
                    </div>
                }
                @case ('ok') {
                    <legend>Paso {{ stepNumber }} de {{ totalSteps }}</legend>
                    <div class="public-form__step">
                        @if (currentTemplate) {
                            <ng-container *ngTemplateOutlet="currentTemplate; context: { $implicit: errors }"></ng-container>
                        }
                    </div>
                    @if (errorText) {
                        <div class="errorValidation public-form__error">
                            <p>{{ errorText }}</p>
                        </div>
                    }
                    <div class="public-form__buttons">
                        <button type="button" pButton [label]="nextLabel" [disabled]="busy" [loading]="busy"
                            class="w-full p-3 text-xl button-primary" (click)="next()"></button>
                        @if (canGoBack) {
                            <button type="button" pButton label="Atrás" [disabled]="busy" [text]="true"
                                class="w-full p-3 text-xl" (click)="back()"></button>
                        }
                    </div>
                }
                @default {
                    @if (message) {
                        <div class="public-form__status">
                            <i class="pi public-form__icon" [ngClass]="currentState === 'done' ? 'pi-check-circle public-form__icon--ok' : 'pi-exclamation-circle'"></i>
                            <h2>{{ message.title }}</h2>
                            <p>{{ message.text }}</p>
                        </div>
                    }
                }
            }
        </div>
    </div>
</div>
